// For holding color variables needed to be added directly to js files
export const DARK_BG_COLOR = '#212529';
export const LIGHT_GREY = '#cacaca';
